import React, { useState, useEffect } from "react";
import AdminToolsDataService from "../../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";

import Create_icon from "../../../assets/images/create_icon.png";
import Edit_icon from "../../../assets/images/icons/edit_icon.svg";
import Delete_iconbl from "../../../assets/images/icons/delete_iconbl.svg";
import { useTranslation } from "react-i18next";
import { Button, Modal, Spin, Switch, Table, Tooltip } from "antd";

const initialPartnerData = {
  partnerTypeId: 0,
  partnerTypeName: "",
  joiningCode: "",
  isActive: true,
};

// Generate a readable joining code, e.g. "AGS-7F3K9Q".
const generateJoiningCode = (name) => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let suffix = "";
  for (let i = 0; i < 6; i++) {
    suffix += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  const prefix = (name || "")
    .replace(/[^a-zA-Z]/g, "")
    .substring(0, 3)
    .toUpperCase();
  return prefix ? `${prefix}-${suffix}` : suffix;
};

const PartnerTypes = () => {
  const { t } = useTranslation();
  const [partnerTypeData, setPartnerTypeData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [getloading, setGetLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [partnerData, setPartnerData] = useState(initialPartnerData);
  const [isEdit, setIsEdit] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [validations, setValidations] = useState({
    partnerNameVal: "",
    joiningCodeVal: "",
  });
  const [delData, setDelData] = useState({
    partnerTypeId: 0,
  });

  useEffect(() => {
    handleGetPartnerTypes();
  }, []);

  const handleCancel = () => {
    setVisible(false);
    setPartnerData(initialPartnerData);
    setValidations({
      partnerNameVal: "",
      joiningCodeVal: "",
    });
    setIsEdit(false);
  };

  const handleGetPartnerTypes = (deleteCount) => {
    let inputData = {
      partnerTypeId: 0,
    };
    setGetLoading(true);
    AdminToolsDataService.GetPartnerTypes(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;

        if (message === "Success") {
          setPartnerTypeData(responseData || []);
          if (deleteCount) {
            var count = responseData?.length % 10;
            if (count == 0) {
              setPage(page - 1);
            }
          }
        } else {
          setPartnerTypeData([]);
        }
      })
      .catch((error) => {
        setGetLoading(false);
        console.log(error);
      })
      .finally(() => {
        setGetLoading(false);
      });
  };

  const handleOnChange = (e, isSelect, name) => {
    if (isSelect === "select") {
      setPartnerData({
        ...partnerData,
        [name]: e,
      });
    } else {
      setPartnerData({
        ...partnerData,
        [e.target.name]: e.target.value,
      });
      setValidations((prev) => ({
        ...prev,
        [`${e.target.name}Val`]: "",
      }));
    }
  };

  const handleGenerateCode = () => {
    setPartnerData((prev) => ({
      ...prev,
      joiningCode: generateJoiningCode(prev.partnerTypeName),
    }));
    setValidations((prev) => ({ ...prev, joiningCodeVal: "" }));
  };

  const handleValidation = () => {
    const { partnerTypeName, joiningCode } = partnerData;
    const newValidations = {
      partnerNameVal: "",
      joiningCodeVal: "",
    };
    let isValid = true;

    if (!partnerTypeName.trim()) {
      isValid = false;
      newValidations.partnerNameVal = t("Partner Name is compulsory");
    }
    if (!joiningCode.trim()) {
      isValid = false;
      newValidations.joiningCodeVal = t("Joining Code is compulsory");
    }
    setValidations(newValidations);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = handleValidation();
    if (!isValid) {
      return false;
    }
    let inputData = {
      partnerTypeId: partnerData.partnerTypeId,
      partnerTypeName: partnerData.partnerTypeName,
      joiningCode: partnerData.joiningCode,
      isActive: partnerData.isActive,
      isEdit: isEdit == true ? true : false,
    };
    setSubmitLoading(true);
    AdminToolsDataService.SavePartnerType(inputData)
      .then((response) => {
        var message = response.data.message;
        if (message === "Success") {
          if (isEdit) {
            NotificationManager.success(
              t("Partner Type Has Been Updated Successfully")
            );
          } else {
            NotificationManager.success(
              t("Partner Type Has Been Added Successfully")
            );
          }
          handleCancel();
          handleGetPartnerTypes();
        } else if (message === "DuplicateCode") {
          setValidations((prev) => ({
            ...prev,
            joiningCodeVal: t("Joining code already in use"),
          }));
        } else {
          setValidations((prev) => ({
            ...prev,
            partnerNameVal: t("Data Already Exists"),
          }));
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  const handleEditModal = (row) => {
    setVisible(true);
    setIsEdit(true);
    setPartnerData({
      partnerTypeId: row.partnerTypeId,
      partnerTypeName: row.partnerTypeName,
      joiningCode: row.joiningCode,
      isActive: row.isActive,
    });
  };

  const handleDeleteModal = (row) => {
    setVisible2(true);
    setDelData({
      partnerTypeId: row.partnerTypeId,
    });
  };

  const handleCancel2 = () => {
    setVisible2(false);
    setDelData({
      partnerTypeId: 0,
    });
  };

  const handleDelSubmit = () => {
    let inputData = {
      partnerTypeId: parseInt(delData.partnerTypeId),
    };
    AdminToolsDataService.DeletePartnerType(inputData)
      .then((response) => {
        var message = response.data.message;
        if (message === "Success") {
          NotificationManager.success(
            t("Partner Type Has Been Deleted Successfully.")
          );
          handleGetPartnerTypes("1");
        } else {
          NotificationManager.error(t("Partner Type Has Not Been Deleted."));
        }
      })
      .catch((error) => {
        console.log(error);
      });
    handleCancel2();
  };

  const { partnerTypeName, joiningCode, isActive } = partnerData;

  return (
    <React.Fragment>
      <div className="addcolor__section">
        <div className="form__fields">
          <div className="row">
            <div className="col-lg-12">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <h4 className="workarea__heading mt-0 mb-0">
                    {t("Partner Types")}
                  </h4>
                </div>
                <div className="col-lg-6">
                  <div className="addcolor__btndiv text-left-mobile">
                    <button
                      className="primary-btn"
                      onClick={() => setVisible(true)}
                    >
                      <img src={Create_icon} alt="" /> {t("Add Partner Type")}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-12 mt-3">
              <div className="addcolor_tbldiv">
                <Spin spinning={getloading} size="large">
                  <Table
                    scroll={{ x: "max-content" }}
                    pagination={{
                      size: "small",
                      onChange(current, pageSize) {
                        setPage(current);
                        setPageSize(pageSize);
                      },
                      showSizeChanger: true,
                      responsive: true,
                    }}
                    columns={[
                      {
                        title: (
                          <Tooltip title={t("Sr. No.")}>
                            {t("Sr. No.")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        render: (value, item, index) =>
                          (page - 1) * pageSize + index + 1,
                      },
                      {
                        title: (
                          <Tooltip title={t("Partner Name")}>
                            {t("Partner Name")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "partnerTypeName",
                      },
                      {
                        title: (
                          <Tooltip title={t("Joining Code")}>
                            {t("Joining Code")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "joiningCode",
                      },
                      {
                        title: (
                          <Tooltip title={t("Active")}>{t("Active")}</Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "isActive",
                        Key: "isActive",
                        render: (item) => {
                          return item ? "Yes" : "No";
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Action")}>{t("Action")}</Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "action",
                        render: (index, row) => (
                          <div className="action__btns">
                            <div className="image__block">
                              <img
                                src={Edit_icon}
                                onClick={() => {
                                  handleEditModal(row);
                                }}
                                alt=""
                              />
                            </div>
                            <div className="image__block">
                              <img
                                src={Delete_iconbl}
                                onClick={() => {
                                  handleDeleteModal(row);
                                }}
                                alt=""
                              />
                            </div>
                          </div>
                        ),
                      },
                    ]}
                    dataSource={partnerTypeData}
                  />
                </Spin>
              </div>
            </div>

            <div className="col-lg-12">
              <Modal
                title={
                  isEdit === false
                    ? t("Add Partner Type")
                    : t("Edit Partner Type")
                }
                className="modal__addcolor"
                centered
                visible={visible}
                onOk={() => setVisible(false)}
                onCancel={handleCancel}
                width={400}
                footer={[
                  <Button key="back" onClick={handleCancel}>
                    {t("Cancel")}
                  </Button>,
                  <Button
                    key="submit"
                    type="primary"
                    loading={submitLoading}
                    onClick={handleSubmit}
                  >
                    {isEdit === false ? t("Add") : t("Update")}
                  </Button>,
                ]}
              >
                <div className="col-lg-12">
                  <div className="modal__body">
                    <div className="col-lg-12">
                      <div className="form__fields border-0 p-0">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="input__block">
                              <label> {t("Partner Name")} </label>
                              <input
                                type="text"
                                placeholder={t("Enter Partner Name")}
                                name="partnerTypeName"
                                value={partnerTypeName}
                                onChange={handleOnChange}
                                className={
                                  validations.partnerNameVal && "border__red"
                                }
                              />
                              <div>
                                {validations.partnerNameVal && (
                                  <p className="error-color-red">
                                    {validations.partnerNameVal}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="input__block">
                              <label> {t("Joining Code")} </label>
                              <div className="d-flex" style={{ gap: "8px" }}>
                                <input
                                  type="text"
                                  placeholder={t("Enter Joining Code")}
                                  name="joiningCode"
                                  value={joiningCode}
                                  onChange={handleOnChange}
                                  className={
                                    validations.joiningCodeVal && "border__red"
                                  }
                                />
                                <Button onClick={handleGenerateCode}>
                                  {t("Generate")}
                                </Button>
                              </div>
                              <div>
                                {validations.joiningCodeVal && (
                                  <p className="error-color-red">
                                    {validations.joiningCodeVal}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-6">
                            <div className="input__block">
                              <label> {t("Active")}</label>
                              <Switch
                                name="isActive"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={isActive}
                                onChange={(e) =>
                                  handleOnChange(e, "select", "isActive")
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>

              <Modal
                className="datamapping__modal"
                centered
                visible={visible2}
                onOk={() => setVisible2(false)}
                onCancel={() => setVisible2(false)}
                width={400}
                footer={[
                  <Button key="back" onClick={handleCancel2}>
                    {t("Cancel")}
                  </Button>,
                  <Button key="submit" type="primary" onClick={handleDelSubmit}>
                    {t("Delete")}
                  </Button>,
                ]}
              >
                <div className="col-lg-12">
                  <div className="modal__body">
                    <div className="col-lg-12">
                      <div className="form__fields border-0 p-0">
                        <div className="row">
                          <div className="col-lg-12 text-center">
                            <p className="subheading">
                              {t("Are you sure you want to delete")} ?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PartnerTypes;
